var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"pie-nest"},[_c('header',{staticClass:"pie-nest-title"},[_vm._v(_vm._s(_vm.title))]),_c('section',{staticClass:"echarts-warpper"},[_c('e-charts',{ref:"echarts",attrs:{"options":_vm.options}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }